import type { Booking } from '#domain/Booking.ts';

export type BookingState = 'NONE' | 'CONFIRMED' | 'PENDING' | 'DEACTIVATED';

export const getAccountBookingState = (booking: Booking): BookingState => {
    if (booking.booking === 'NONE') {
        return 'NONE';
    }
    return booking.status;
};

export const hasBookingState = (booking?: Booking, ...allowedStates: BookingState[]) => {
    if (!booking) {
        return false;
    }
    const state = getAccountBookingState(booking);
    return allowedStates.includes(state);
};
